/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Answer_Not_FoundInputs */

const en_answer_not_found = /** @type {(inputs: Answer_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found`)
};

const nl_answer_not_found = /** @type {(inputs: Answer_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet gevonden`)
};

/**
* | output |
* | --- |
* | "Not found" |
*
* @param {Answer_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const answer_not_found = /** @type {((inputs?: Answer_Not_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Answer_Not_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_answer_not_found(inputs)
	return en_answer_not_found(inputs)
});